module.exports = __webpack_public_path__ + "static/img/05.b86b392.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news21/05.png
// module id = PHMs
// module chunks = 1